import axios from 'axios';
import { default as Server } from './server';

const DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-Token': Server.getVar('APP_TOKEN'),
};

const Http = {
  handleResponse: (response: any) => {
    if (response.status === 500) {
      return Promise.reject(new Error('Something went wrong.'));
    }
    return response.data;
  },

  post: (url: string, data = {}) =>
    axios.post(url, data, { headers: DEFAULT_HEADERS }).then(Http.handleResponse),

  get: (url: string, headers = DEFAULT_HEADERS) =>
    axios.get(url, { headers }).then(Http.handleResponse),
};

export default Http;
